<template>
    <div class="w-full">
        <div class="flex justify-between px-2 mt-8">
            <div class="pr-2 w-1/2">
                <datepicker
                    class="test"
                    input-class="form-control"
                    placeholder="Datum isporuke od:"
                    :language="locale"
                    v-model="selectedDateFrom"
                ></datepicker>
            </div>

            <div class="pl-2 w-1/2">
                <datepicker
                    input-class="form-control "
                    placeholder="Datum isporuke do:"
                    :language="locale"
                    v-model="selectedDateTo"
                ></datepicker>
            </div>
        </div>

        <div class="flex justify-between mt-4">
            <button
                @click="exportFiltered"
                class="btn btn-export text-lg border-hl_yellow hover:border-yellow mt-6"
            >
                <span>Izvoz podataka</span>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { hr } from "vuejs-datepicker/dist/locale";

export default {
    components: {
        vSelect,
        Datepicker,
    },

    mounted() {},

    data() {
        return {
            selectedDateFrom: "",
            selectedDateTo: "",
            locale: hr,
        };
    },

    methods: {
        exportFiltered() {
            let filterData = {};

            if (!this.selectedDateFrom || !this.selectedDateTo) {
                return;
            }

            if (this.selectedDateFrom) {
                filterData['selectedDateFrom'] = this.selectedDateFrom;
            }

            if (this.selectedDateTo) {
                filterData['selectedDateTo'] = this.selectedDateTo;
            }

            window.location = route("admin.export.equipment-per-move", filterData);
        },
    },
};
</script>
